/* Tobari Hijabs: site animations.
   Switched on per effect from Theme settings → Tobari animations (body classes tb-a-*).
   Does nothing for people who turn off motion on their phone or computer. */
(function () {
  'use strict';

  var body = document.body;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function on(name) { return body.classList.contains('tb-a-' + name); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Sakura petals (also used by the countdown burst) ---------- */
  var PETAL = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1C6 4 3.5 8 4.5 12.5 5.4 16.6 8.4 19 10 19c1.6 0 4.6-2.4 5.5-6.5C16.5 8 14 4 10 1z" fill="var(--c,#f6bccb)"/><path d="M10 4.5v12" stroke="#e98fa6" stroke-width=".7" opacity=".55"/></svg>';
  var PINKS = ['#f9c9d4', '#f6bccb', '#f3aec0', '#fbd8e0', '#efa2b6'];
  function layer() {
    var l = document.createElement('div');
    l.className = 'tb-petals';
    l.setAttribute('aria-hidden', 'true');
    body.appendChild(l);
    return l;
  }
  function rand(a, b) { return a + Math.random() * (b - a); }

  function petalRain(count) {
    if (reduce) return;
    var l = layer();
    var longest = 0;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      p.className = 'tb-petal';
      var d = rand(6, 10), w = rand(0, 4);
      longest = Math.max(longest, d + w);
      p.style.left = rand(0, 100) + 'vw';
      p.style.setProperty('--s', rand(10, 20) + 'px');
      p.style.setProperty('--d', d + 's');
      p.style.setProperty('--w', w + 's');
      p.style.setProperty('--x', rand(-120, 160) + 'px');
      p.style.setProperty('--c', PINKS[i % PINKS.length]);
      p.innerHTML = PETAL;
      l.appendChild(p);
    }
    setTimeout(function () { l.remove(); }, (longest + 0.5) * 1000);
  }

  function petalBurst(x, y) {
    if (reduce) return;
    var l = layer();
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('span');
      p.className = 'tb-petal tb-burst';
      var ang = rand(0, Math.PI * 2), dist = rand(80, 240);
      p.style.setProperty('--x0', x + 'px');
      p.style.setProperty('--y0', y + 'px');
      p.style.setProperty('--bx', Math.cos(ang) * dist + 'px');
      p.style.setProperty('--by', Math.sin(ang) * dist + rand(20, 90) + 'px');
      p.style.setProperty('--s', rand(10, 18) + 'px');
      p.style.setProperty('--d', rand(1.6, 2.6) + 's');
      p.style.setProperty('--c', PINKS[i % PINKS.length]);
      p.innerHTML = PETAL;
      l.appendChild(p);
    }
    setTimeout(function () { l.remove(); }, 3000);
    setTimeout(function () { petalRain(18); }, 400);
  }

  /* Called by the countdown in tobari.js when it reaches zero while someone is watching */
  window.TobariMotion = {
    dropLive: function (bar) {
      var box = bar.querySelector('.tobari-restock-units, .tobari-drop-countdown__units') || bar;
      var label = bar.querySelector('.tobari-drop-countdown__label');
      if (label) label.remove();
      var msg = document.createElement('p');
      msg.className = 'tb-out-now';
      msg.innerHTML = '<span>Out now ✦</span><button type="button">Shop the drop</button>';
      msg.querySelector('button').addEventListener('click', function () { location.reload(); });
      box.replaceWith(msg);
      if (on('flip') || on('petals')) {
        var r = msg.getBoundingClientRect();
        petalBurst(r.left + r.width / 2, r.top + r.height / 2);
      }
    }
  };

  if (on('petals')) {
    var isHome = body.getAttribute('data-tb-template') === 'index';
    var preview = body.hasAttribute('data-tb-petals-preview');
    var dropDate = (body.getAttribute('data-tb-drop-date') || '').trim();
    var showDays = Number(body.getAttribute('data-tb-petal-days') || 3);
    var live = false;
    var m = dropDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      // 10:00 UK time. BST (UTC+1) runs late March to late October; 26 Oct is after the clocks change, so use a safe check.
      var start = Date.UTC(+m[1], +m[2] - 1, +m[3], 10, 0, 0);
      var offset = londonOffsetMinutes(new Date(start));
      start -= offset * 60000;
      var now = Date.now();
      live = now >= start && now < start + showDays * 86400000;
    }
    var seen = false;
    try { seen = sessionStorage.getItem('tbPetalsSeen') === '1'; } catch (e) {}
    if (isHome && (preview || (live && !seen))) {
      window.addEventListener('load', function () { setTimeout(function () { petalRain(28); }, 500); });
      try { sessionStorage.setItem('tbPetalsSeen', '1'); } catch (e) {}
    }
  }

  function londonOffsetMinutes(date) {
    try {
      var s = date.toLocaleString('en-GB', { timeZone: 'Europe/London', timeZoneName: 'short' });
      return /BST/.test(s) ? 60 : 0;
    } catch (e) { return 0; }
  }

  if (reduce) return;

  /* ---------- 1. Fade-up on scroll ---------- */
  if (on('fade') && 'IntersectionObserver' in window) {
    var targets = qsa('#MainContent > .shopify-section').slice(1)
      .concat(qsa('#MainContent [data-product-card]').filter(function (el) {
        return !el.closest('[data-tobari-auto-marquee]');
      }));
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      var batch = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute('data-product-card')) el.style.setProperty('--tb-delay', Math.min(batch++, 6) * 80 + 'ms');
        el.classList.add('tb-in');
        io.unobserve(el);
        setTimeout(function () { el.classList.remove('tb-reveal', 'tb-in'); el.style.removeProperty('--tb-delay'); }, 1600);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      // Only hide things that start below the screen, so nothing flashes on load.
      if (el.getBoundingClientRect().top > vh) {
        el.classList.add('tb-reveal');
        io.observe(el);
      }
    });
  }

  /* ---------- 2. Second photo: swipe on phones ---------- */
  if (on('photo')) {
    qsa('.product-card .media.has-alt').forEach(function (media) {
      var dots = document.createElement('span');
      dots.className = 'tb-photo-dots';
      dots.innerHTML = '<i class="on"></i><i></i>';
      media.appendChild(dots);
      var x0 = null, y0 = null;
      media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          var show = dx < 0;
          media.classList.toggle('tb-show-alt', show);
          dots.children[0].classList.toggle('on', !show);
          dots.children[1].classList.toggle('on', show);
        }
      }, { passive: true });
    });
  }

  /* ---------- 3. Add to cart feedback: cart icon bounces when the count goes up ---------- */
  if (on('added')) {
    qsa('[data-cart-count]').forEach(function (count) {
      var last = parseInt(count.textContent, 10) || 0;
      new MutationObserver(function () {
        var n = parseInt(count.textContent, 10) || 0;
        if (n > last) {
          var link = count.closest('.cart-link') || count.parentElement;
          link.classList.remove('tb-bounce');
          void link.offsetWidth;
          link.classList.add('tb-bounce');
        }
        last = n;
      }).observe(count, { childList: true, characterData: true, subtree: true });
    });
    // Quick add buttons: pop when they change to "Added ✓"
    qsa('[data-ajax-add]').forEach(function (btn) {
      new MutationObserver(function () {
        if (/Added/.test(btn.textContent)) {
          btn.classList.remove('tb-added-pop');
          void btn.offsetWidth;
          btn.classList.add('tb-added-pop');
        }
      }).observe(btn, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- 4. Anime tile glow on tap (phones) ---------- */
  if (on('glow')) {
    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest && e.target.closest('.anime-card');
      qsa('.anime-card.tb-glow-on').forEach(function (c) { if (c !== card) c.classList.remove('tb-glow-on'); });
      if (card) card.classList.add('tb-glow-on');
    }, { passive: true });
  }

  /* ---------- 6. Flip-clock countdown ---------- */
  if (on('flip')) {
    qsa('[data-tobari-restock-countdown] b').forEach(function (b) {
      var last = b.textContent;
      new MutationObserver(function () {
        if (b.textContent === last) return;
        last = b.textContent;
        b.classList.remove('tb-flip');
        void b.offsetWidth;
        b.classList.add('tb-flip');
      }).observe(b, { childList: true, characterData: true, subtree: true });
    });
  }
})();

/* ---------- 3b. Product page: add to cart without leaving the page ---------- */
(function () {
  'use strict';
  var body = document.body;
  if (!body.classList.contains('tb-a-stay')) return;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('tobari-product__form') || e.defaultPrevented) return;
    var btn = form.querySelector('[data-tobari-add]');
    if (!btn || btn.disabled) return;
    if (e.submitter && e.submitter !== btn) return;

    e.preventDefault();
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
          el.style.display = cart.item_count > 0 ? 'grid' : 'none';
        });
        btn.textContent = 'Added ✓';
        btn.classList.add('tb-added-pop');
        setTimeout(function () {
          btn.innerHTML = original;
          btn.disabled = false;
          btn.classList.remove('tb-added-pop');
        }, 2600);
      })
      .catch(function () {
        // Anything unusual (e.g. not enough stock): fall back to the normal add to cart.
        btn.innerHTML = original;
        btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      });
  });
})();
